import { render, staticRenderFns } from "./SkeletonLoader.vue?vue&type=template&id=92c6b7ce"
var script = {}
import style0 from "./SkeletonLoader.vue?vue&type=style&index=0&id=92c6b7ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports